import styled, { css } from 'styled-components';
import EmptyState from '../../empty-state/EmptyState';
import Input from '../../input/Input';
import { PlaceholderLabel } from '../../input/styles';
import Radio from '../../radio/Radio';
import Typography from '../../typography/Typography';
export const DROPDOWN_MODAL_MAX_HEIGHT = 357;
export const DROPDOWN_MODAL_MAX_HEIGHT_WITHOUT_FOOTER_AND_HEADER = 240;
export const SelectIconWrapper = styled.div `
  margin-right: 1.2rem;
`;
export const Img = styled.img `
  max-height: 4rem;
`;
export const ValueText = styled(Typography) `
  ${({ hasOtherContent }) => hasOtherContent
    ? css `
          max-width: 90%;
          white-space: nowrap;
          overflow: hidden !important;
          text-overflow: ellipsis;
        `
    : null}
`;
export const Separator = styled.div `
  height: 1.6rem;

  ${({ theme, isLast, disabled }) => {
    const height = `${isLast ? 0 : 0.1}rem`;
    const bgc = (disabled
        ? theme.colors.borders.disabled
        : theme.colors.borders.default);
    return theme.media.tablet `
      height: ${height};
      background-color: ${bgc};
    `;
}};
`;
export const VerticalSeparator = styled.div `
  width: 0.1rem;
  min-height: 100%;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;
export const ModalWrapper = styled.div `
  ${({ theme }) => theme.media.tablet `
    display: none;
  `};
`;
export const List = styled.ul.attrs(({ ref }) => ({ ref })) `
  width: 100%;
  max-height: 30rem;

  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 0.3rem;
  }
`;
export const WideOptionContainer = styled.div `
  display: none;
  position: absolute;
  min-width: max-content;
  width: calc(100% + 0.2rem);

  top: -0.1rem;

  ${({ JustifyToRight }) => JustifyToRight
    ? css `
          right: -0.1rem;
          left: unset;
        `
    : css `
          left: -0.1rem;
          right: 0;
        `}

  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.borders.default};

  z-index: ${({ theme }) => theme.zIndex.medium};

  background-color: ${({ theme }) => theme.colors.surface.default};
  overflow: hidden;

  box-shadow: ${({ theme }) => theme.shadows.xl2};

  ${({ theme }) => theme.media.tablet `
      display: flex;
      flex-direction:column;
  `};
`;
export const IconWrapper = styled.div `
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  transition: transform 0.3s ease;

  padding: 0 0.8rem;
`;
export const Placeholder = styled(PlaceholderLabel) `
  height: auto;
  left: ${({ hasIcon }) => (hasIcon ? 5.3 : 0)}rem;
`;
export const CustomSelect = styled.div `
  position: relative;

  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: ${({ valueSize }) => (valueSize === 'lg' ? '6.2' : '5.4')}rem;

  padding: 0.5rem 1.8rem;

  border: none;
  cursor: ${({ isDisabled }) => (isDisabled ? 'default' : 'pointer')};
  box-shadow: none;

  border: ${({ theme, hasError, isDisabled }) => {
    if (isDisabled)
        return `1px solid ${theme.colors.borders.disabled};`;
    return hasError
        ? `1px solid ${theme.colors.borders.critical};`
        : `1px solid ${theme.colors.borders.default};`;
}};
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme, isDisabled }) => isDisabled
    ? theme.colors.surface.disabled
    : theme.colors.surface.interactiveDefault};
  ${({ theme, menuIsOpen }) => menuIsOpen &&
    css `
      background-color: ${theme.colors.surface.hover};
      border: 1px solid ${theme.colors.borders.pressed};
    `}

  &:hover {
    ${({ theme, isDisabled, hasError, menuIsOpen }) => {
    if (isDisabled)
        return css `
          border: 1px solid ${theme.colors.borders.disabled};
          background-color: ${theme.colors.surface.disabled};
        `;
    if (hasError)
        return css `
          border: 1px solid ${theme.colors.borders.critical};
          background-color: ${theme.colors.surface.interactiveDefault};
        `;
    if (menuIsOpen)
        return css `
          background-color: ${theme.colors.surface.hover};
          border: 1px solid ${theme.colors.borders.pressed};
        `;
    return css `
        border: 1px solid ${theme.colors.borders.hover};
        background-color: ${theme.colors.surface.hover};
      `;
}}
  }
`;
export const ModalContent = styled.div ``;
export const ModalOptionsWrapper = styled.div `
  max-height: 30rem;

  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;
export const CustomEmptyState = styled(EmptyState) `
  padding: 2rem 0;
`;
export const CustomValueWrapper = styled.div `
  position: relative;
  display: flex;
  flex: 1;
  align-items: ${({ placeholder, textAfterSelection }) => placeholder || textAfterSelection ? 'end' : 'center'};

  height: 100%;
  max-height: 4.2rem;

  background-color: ${({ theme, disabled }) => !disabled ? '' : theme.colors.surface.disabled};

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : '')};
  opacity: ${({ disabled }) => (disabled ? '0.6' : '')};
`;
export const ValueWrapper = styled.div `
  flex: 1;
  display: flex;

  height: 100%;
  align-items: center;
`;
export const CustomRadio = styled(Radio) `
  ${({ theme, checked }) => !checked ? 'background-color: ' + theme.colors.surface.default : ''};

  ${({ theme }) => theme.media.tablet `
    border: none;
    border-radius: unset;
  `};
`;
export const OptionContainer = styled.div `
  display: flex;
  align-items: center;

  margin: 0;
`;
export const CustomInput = styled(Input) `
  margin: 2.2rem;
  width: auto;
`;
export const CustomTypography = styled(Typography) `
  text-align: center;
  margin-top: 2.6rem;
  margin-bottom: 0.2rem;
`;
//# sourceMappingURL=styles.js.map